import * as Table from '../Table';
import styles from './styles/Draggable.module.css';

type Props = {
  value: number;
};

export const Cell = (props: Props) => {
  return <Table.Body.TD className={styles.ordinal}>{props.value}</Table.Body.TD>;
};

Cell.displayName = 'Column.Ordinal.Cell';

export const Header = (props: unknown) => {
  return <Table.Header.TH className={styles.ordinal}>Order</Table.Header.TH>;
};

Header.displayName = 'Column.Ordinal.Header';
